export default __webpack_public_path__ + "static/media/bin.1fd70734.svg";